import { useMemo } from 'react'

import { useAPIGetPenetapanPredikatKinerjaStep } from 'api/kinerja/useAPIKinerja'
import useDemoContext from 'app/KinerjaPage/hooks/useDemoContext'
import { LangkahObservasiCard } from 'app/KinerjaPage/pages/PelaksanaanV2/components/LangkahObservasiCard'
import { PENETAPAN_PREDIKAT_KINERJA_STEPS } from 'app/KinerjaShared/constants/penetapanPredikatKinerja'

import type {
  LangkahObservasiCardProps,
  LangkahObservasiState,
} from 'app/KinerjaPage/pages/PelaksanaanV2/components/LangkahObservasiCard'

export const LangkahMenungguPredikatKinerjaCard = (
  props: LangkahObservasiCardProps
) => {
  const { isDemoMode } = useDemoContext()

  const { data, isLoading } = useAPIGetPenetapanPredikatKinerjaStep({
    params: {
      npsn: props?.npsn,
    },
    options: {
      useErrorBoundary: false,
      staleTime: 60 * 60 * 1000, // 1 hour
    },
    isDemoMode,
  })

  const overrideState: LangkahObservasiState = useMemo(() => {
    const currentStepOrder =
      PENETAPAN_PREDIKAT_KINERJA_STEPS[data?.data?.submissionStep]?.order ?? 0
    const cardStepOrder = PENETAPAN_PREDIKAT_KINERJA_STEPS['SUBMIT_KADIS'].order

    if (cardStepOrder === currentStepOrder) return 'unlocked'
    if (currentStepOrder > cardStepOrder) return 'done'
    return 'locked'
  }, [data])

  return (
    <LangkahObservasiCard
      {...props}
      isLoading={isLoading}
      overrideState={overrideState}
    />
  )
}
